/* KiddoJoy - minimales Theme-Skript, kein Framework. */

(function () {
  'use strict';

  /* Mobiles Menü als Schublade */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-drawer]');

  if (header && toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = !header.classList.contains('is-open');
      header.classList.toggle('is-open', open);
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || drawer.hidden) return;
      header.classList.remove('is-open');
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* Der eine Bewegungsmoment: Hero-Aufbau nach dem Laden. */
  requestAnimationFrame(function () {
    document.body.classList.add('is-ready');
  });

  /* Variantenauswahl auf der Produktseite */
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
  var selects = form.querySelectorAll('[data-option-index]');
  var idField = form.querySelector('[name="id"]');
  var priceEl = document.querySelector('[data-price-value]');
  var buybarPrice = document.querySelector('[data-buybar-price]');
  var button = form.querySelector('[data-add-button]');

  function currentOptions() {
    return Array.prototype.map.call(selects, function (s) {
      if (s.tagName === 'SELECT') return s.value;
      var checked = s.querySelector('input:checked');
      return checked ? checked.value : '';
    });
  }

  function matchVariant() {
    var chosen = currentOptions();
    return variants.filter(function (v) {
      return chosen.every(function (value, i) { return v.options[i] === value; });
    })[0];
  }

  function update() {
    var variant = matchVariant();

    if (!variant) {
      button.disabled = true;
      button.textContent = 'Nicht verfügbar';
      return;
    }

    idField.value = variant.id;

    /* Nur der Preis wird getauscht, die Zeile mit MwSt. und Versand bleibt. */
    if (priceEl && variant.price_formatted) {
      if (variant.compare_formatted) {
        priceEl.innerHTML =
          '<span class="price--was">' + variant.compare_formatted + '</span>' +
          '<span class="price--sale">' + variant.price_formatted + '</span>' +
          '<span class="product__save">' + variant.saved_formatted + ' gespart</span>';
      } else {
        priceEl.textContent = variant.price_formatted;
      }
    }
    if (buybarPrice && variant.price_formatted) buybarPrice.textContent = variant.price_formatted;

    button.disabled = !variant.available;
    button.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
  }

  Array.prototype.forEach.call(selects, function (s) {
    s.addEventListener('change', update);
  });

  update();
})();

/* Hinweisleiste: wechselt die Nachrichten alle sechs Sekunden. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-announce]');
  if (!bar) return;

  var items = bar.querySelectorAll('.announce__item');
  if (items.length < 2) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var index = 0;
  setInterval(function () {
    items[index].classList.remove('is-on');
    index = (index + 1) % items.length;
    items[index].classList.add('is-on');
  }, 6000);
})();

/* Anmeldefenster. Nicht mehr nach Zeit allein: erst Verzoegerung abgewartet
   UND mindestens einen Bildschirm gescrollt, auf dem Laptop auch beim
   Verlassen des Fensters nach oben. Auf dem Handy als Leiste von unten, nie
   auf Produktseiten, damit es nicht ueber Bild und Kaufknopf liegt. Nach
   Schliessen oder Eintragen 14 Tage Ruhe. */
(function () {
  'use strict';

  var modal = document.querySelector('[data-signup]');
  if (!modal) return;

  var KEY = 'kiddojoy-signup-until';
  var SENT = 'kiddojoy-signup-sent';
  var TAGE = 14;
  var jetzt = Date.now();

  function lesen(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function schreiben(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }

  function ruhe() {
    schreiben('localStorage', KEY, String(Date.now() + TAGE * 864e5));
    schreiben('sessionStorage', KEY, '1');
  }

  /* Wer gerade ueber den Link in der Mail kommt, ist schon eingetragen. */
  if (/^\/account\/(subscribe|unsubscribe)/.test(window.location.pathname)) { ruhe(); return; }

  var schmal = window.matchMedia('(max-width: 760px)').matches;
  var seite = modal.getAttribute('data-page') || '';
  var offen = false;

  function oeffnen() {
    if (offen) return;
    offen = true;
    modal.hidden = false;
    modal.classList.toggle('signup--sheet', schmal);
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
    var feld = modal.querySelector('input[type="email"]');
    if (feld && !schmal) setTimeout(function () { feld.focus({ preventScroll: true }); }, 250);
  }

  function schliessen() {
    modal.classList.remove('is-on');
    setTimeout(function () { modal.hidden = true; }, 250);
    ruhe();
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-signup-close]')) schliessen();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) schliessen();
  });

  var form = modal.querySelector('form');
  if (form) form.addEventListener('submit', function () { schreiben('sessionStorage', SENT, '1'); ruhe(); });

  /* Nach dem Absenden laedt Shopify die Seite mit customer_posted=true neu.
     Kam das Absenden aus diesem Fenster, zeigen wir sofort die Bestaetigung. */
  if (/customer_posted=true/.test(window.location.search) && lesen('sessionStorage', SENT)) {
    try { window.sessionStorage.removeItem(SENT); } catch (e) {}
    modal.classList.add('is-ok');
    var titel = modal.querySelector('.signup__body h2');
    var zeile = modal.querySelector('.signup__eyebrow');
    if (titel) titel.textContent = 'Dein Code ist da';
    if (zeile) zeile.textContent = 'Danke fürs Eintragen';
    oeffnen();
    return;
  }

  var bis = parseInt(lesen('localStorage', KEY), 10);
  if ((bis && bis > jetzt) || lesen('sessionStorage', KEY)) return;
  if (schmal && seite === 'product') return;

  var delay = parseInt(modal.getAttribute('data-delay'), 10);
  if (isNaN(delay)) delay = 8;
  var zeitDa = false, gescrollt = false;

  function pruefen() { if (zeitDa && gescrollt) oeffnen(); }
  setTimeout(function () { zeitDa = true; pruefen(); }, delay * 1000);

  function scroll() {
    if (window.scrollY > window.innerHeight * 0.9) {
      gescrollt = true;
      window.removeEventListener('scroll', scroll);
      pruefen();
    }
  }
  window.addEventListener('scroll', scroll, { passive: true });

  if (!schmal) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && zeitDa) oeffnen();
    });
  }
})();

/* Tagesangebot: Countdown bis Mitternacht in der Zeitzone des Besuchers. */
(function () {
  'use strict';

  var box = document.querySelector('[data-countdown]');
  if (!box) return;

  var h = box.querySelector('[data-cd-h]');
  var m = box.querySelector('[data-cd-m]');
  var s = box.querySelector('[data-cd-s]');

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function tick() {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var left = Math.max(0, Math.floor((midnight - now) / 1000));

    h.textContent = pad(Math.floor(left / 3600));
    m.textContent = pad(Math.floor((left % 3600) / 60));
    s.textContent = pad(left % 60);
  }

  tick();
  setInterval(tick, 1000);
})();

/* Mobiler Kaufbalken: leitet den Klick an das echte Formular weiter. */
(function () {
  'use strict';

  var button = document.querySelector('[data-buybar-add]');
  var form = document.querySelector('[data-product-form]');
  if (!button || !form) return;

  button.addEventListener('click', function () {
    var submit = form.querySelector('[data-add-button]');
    if (submit && !submit.disabled) submit.click();
  });
})();

/* Parallax und Auftauchen. Beides nur, wenn Bewegung erlaubt ist. */
(function () {
  'use strict';

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Elemente tauchen einmal auf, wenn sie in den Blick kommen. */
  var reveals = document.querySelectorAll('.in-view, .reveal-img');

  if (reveals.length && 'IntersectionObserver' in window && !calm.matches) {
    /* Erst ab hier darf das CSS ueberhaupt etwas verstecken. Kommt das Skript
       nie so weit, bleibt die Seite sichtbar statt leer. */
    document.documentElement.classList.add('js-reveal');

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        watcher.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(reveals, function (el) { watcher.observe(el); });
  } else {
    Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); });
  }

  /* Parallax: maximal 60 Pixel Versatz, sonst wirkt es wackelig. */
  var layers = document.querySelectorAll('[data-parallax]');
  if (!layers.length || calm.matches) return;

  var ticking = false;

  function frame() {
    ticking = false;
    var view = window.innerHeight;

    Array.prototype.forEach.call(layers, function (el) {
      var box = el.getBoundingClientRect();
      if (box.bottom < -200 || box.top > view + 200) return;

      var depth = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      var middle = box.top + box.height / 2 - view / 2;
      var shift = Math.max(-60, Math.min(60, middle * -depth));

      el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();
})();

/* Produktgalerie: Miniaturen schalten das grosse Bild um. */
(function () {
  'use strict';

  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  var slides = gallery.querySelectorAll('.gallery__img');
  var thumbs = gallery.querySelectorAll('.gallery__thumb');

  /* Laptop: die Buehne nimmt das Seitenverhaeltnis des ersten Fotos an
     (zwischen quadratisch und 16:9), damit Querformat-Fotos ganz und ohne
     breite Leerflaechen erscheinen. Das Handy bleibt beim festen Format. */
  (function () {
    var stage = gallery.querySelector('.gallery__stage');
    var erstes = gallery.querySelector('img.gallery__img');
    if (!stage || !erstes) return;
    var mq = window.matchMedia('(min-width: 901px)');
    function setzen() {
      if (!mq.matches || !erstes.naturalWidth) { stage.style.aspectRatio = ''; return; }
      var r = erstes.naturalWidth / erstes.naturalHeight;
      r = Math.max(1, Math.min(16 / 9, r));
      stage.style.aspectRatio = String(r);
    }
    if (erstes.complete) setzen(); else erstes.addEventListener('load', setzen, { once: true });
    if (mq.addEventListener) mq.addEventListener('change', setzen);
  })();
  if (!thumbs.length) return;

  function show(index) {
    Array.prototype.forEach.call(slides, function (slide, i) {
      slide.classList.toggle('is-on', i === index);
      /* Ein Video, das aus dem Blick geschoben wird, laeuft sonst weiter. */
      if (i !== index) {
        var v = slide.tagName === 'VIDEO' ? slide : slide.querySelector('video');
        if (v && !v.paused) v.pause();
      }
    });
    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      var on = i === index;
      thumb.classList.toggle('is-on', on);
      thumb.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  Array.prototype.forEach.call(thumbs, function (thumb) {
    thumb.addEventListener('click', function () {
      show(parseInt(thumb.getAttribute('data-goto'), 10) || 0);
    });
  });

  /* Pfeile auf dem Bild: dieselbe Logik wie die Tastatur, nur klickbar. */
  function weiter(schritt) {
    var current = 0;
    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      if (thumb.classList.contains('is-on')) current = i;
    });
    var next = current + schritt;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    show(next);
  }

  var prev = gallery.querySelector('[data-gallery-prev]');
  var next = gallery.querySelector('[data-gallery-next]');
  if (prev) prev.addEventListener('click', function () { weiter(-1); });
  if (next) next.addEventListener('click', function () { weiter(1); });

  gallery.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    var current = 0;
    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      if (thumb.classList.contains('is-on')) current = i;
    });
    var next = event.key === 'ArrowRight' ? current + 1 : current - 1;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    show(next);
    thumbs[next].focus();
  });
})();

/* Zahlen zaehlen einmal hoch, wenn sie sichtbar werden. */
(function () {
  'use strict';

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var numbers = document.querySelectorAll('[data-count]');
  if (!numbers.length || calm || !('IntersectionObserver' in window)) return;

  function run(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;

    var suffix = el.getAttribute('data-suffix') || '';
    var start = performance.now();
    var duration = 1100;

    function step(now) {
      var progress = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (progress < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  var watcher = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      run(entry.target);
      watcher.unobserve(entry.target);
    });
  }, { threshold: 0.5 });

  Array.prototype.forEach.call(numbers, function (el) { watcher.observe(el); });
})();

/* Kopfzeile bekommt Schatten, sobald man scrollt. */
(function () {
  'use strict';

  var header = document.querySelector('.site-header');
  if (!header) return;

  var ticking = false;

  function check() {
    ticking = false;
    header.classList.toggle('is-stuck', window.scrollY > 24);
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(check);
  }, { passive: true });

  check();
})();

/* Ein Tag in Augenhöhe: die Station in Blickmitte bestimmt das Bild. */
(function () {
  'use strict';

  var root = document.querySelector('[data-daytime]');
  if (!root) return;

  var steps = root.querySelectorAll('.daystep');
  var images = root.querySelectorAll('.daytime__img');
  var times = root.querySelectorAll('.daytime__time');
  if (steps.length < 2) return;

  var current = -1;

  function activate(index) {
    if (index === current) return;
    current = index;

    Array.prototype.forEach.call(steps, function (step, i) {
      step.classList.toggle('is-active', i === index);
    });
    Array.prototype.forEach.call(images, function (img, i) {
      img.classList.toggle('is-on', i === index);
    });
    Array.prototype.forEach.call(times, function (time, i) {
      time.classList.toggle('is-on', i === index);
    });
  }

  /* Frueher lief das ueber einen IntersectionObserver. Der meldet nur, wenn
     eine Station in den Blick kommt, nicht wenn man wieder hochscrollt, und
     auf dem Handy verdeckt das feste Bild das obere Drittel. Ergebnis: unten
     stand 15:00, im Bild lief 19:30. Jetzt wird bei jedem Scrollen direkt
     bestimmt, welche Station zuletzt die Grenze passiert hat. Das stimmt in
     beide Richtungen. */
  function bestimmen() {
    var schmal = window.matchMedia('(max-width: 940px)').matches;
    var fest = root.querySelector('.daytime__sticky');
    var grenze;
    if (schmal && fest) {
      /* Mitte des Bereichs, der unter dem festen Bild frei bleibt. Nur
         "knapp unter dem Bild" war zu frueh: sichtbar stand schon 15:00,
         das Bild zeigte noch 10:15. */
      var unten = fest.getBoundingClientRect().bottom;
      grenze = unten + (window.innerHeight - unten) * 0.35;
    } else {
      grenze = window.innerHeight * 0.45;
    }

    var treffer = 0;
    Array.prototype.forEach.call(steps, function (step, i) {
      if (step.getBoundingClientRect().top <= grenze) treffer = i;
    });
    activate(treffer);
  }

  var laeuft = false;
  function anstossen() {
    if (laeuft) return;
    laeuft = true;
    window.requestAnimationFrame(function () {
      laeuft = false;
      bestimmen();
    });
  }

  window.addEventListener('scroll', anstossen, { passive: true });
  window.addEventListener('resize', anstossen);
  bestimmen();
})();

/* Größenberater: drei Fragen, dann der passende Vorschlag. */
(function () {
  'use strict';

  var root = document.querySelector('[data-advisor]');
  if (!root) return;

  var steps = root.querySelectorAll('.advisor__step');
  var results = root.querySelector('[data-advisor-results]');
  var cards = root.querySelectorAll('.advisor__result');
  var bar = root.querySelector('[data-advisor-bar]');
  if (!steps.length || !cards.length) return;

  var answers = [];

  function showStep(index) {
    Array.prototype.forEach.call(steps, function (step, i) {
      step.classList.toggle('is-on', i === index);
    });
    results.classList.remove('is-on');
    if (bar) bar.style.width = ((index + 1) / (steps.length + 1)) * 100 + '%';
  }

  function scoreOf(card) {
    var wanted = (card.getAttribute('data-match') || '').split(',');
    var hits = 0;

    wanted.forEach(function (code) {
      code = code.trim();
      if (code && answers.indexOf(code) !== -1) hits++;
    });

    return hits;
  }

  function finish() {
    var best = cards[0];
    var bestScore = -1;

    Array.prototype.forEach.call(cards, function (card) {
      var score = scoreOf(card);
      if (score > bestScore) {
        bestScore = score;
        best = card;
      }
    });

    Array.prototype.forEach.call(steps, function (step) { step.classList.remove('is-on'); });
    Array.prototype.forEach.call(cards, function (card) { card.classList.toggle('is-on', card === best); });

    results.classList.add('is-on');
    if (bar) bar.style.width = '100%';
  }

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-answer]');

    if (button) {
      answers.push(button.getAttribute('data-answer'));
      if (answers.length >= steps.length) finish();
      else showStep(answers.length);
      return;
    }

    if (event.target.closest('[data-advisor-restart]')) {
      answers = [];
      showStep(0);
    }
  });

  showStep(0);
})();

/* Werkstattvideos: erst beim Klick laden, damit die Seite leicht bleibt. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-video-grid]');
  if (!grid) return;

  grid.addEventListener('click', function (event) {
    var button = event.target.closest('[data-video]');
    if (!button) return;

    var src = button.getAttribute('data-video');
    if (!src) return;

    var frame = button.parentNode;
    var video = document.createElement('video');

    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('playsinline', '');

    frame.replaceChild(video, button);
    video.play().catch(function () {});
  });
})();

/* Bewertungen: Liste, Filter und Nachladen liegen in assets/kj-reviews-ui.js. */

/* Startbild: Foto blendet langsam um, Text und Knoepfe bleiben stehen.
   Nur das erste Bild laedt sofort. Die weiteren bekommen ihre Adresse, sobald
   das erste steht, und es wird nur auf ein Bild gewechselt, das fertig
   geladen ist. Vorher blendete das Handy beim ersten Besuch oft in eine leere
   Flaeche, weil der Wechsel schneller war als das Netz.
   Bei prefers-reduced-motion laeuft kein Automatikwechsel, die Punkte bleiben
   bedienbar. */
(function () {
  'use strict';

  var media = document.querySelector('[data-hero-fade]');
  if (!media) return;

  var bilder = media.querySelectorAll('.hero__img');
  var punkte = media.querySelectorAll('[data-hero-dot]');
  if (bilder.length < 2) return;

  var takt = (parseInt(media.getAttribute('data-interval'), 10) || 7) * 1000;
  if (window.matchMedia('(max-width: 940px)').matches) takt = Math.min(takt, 4500);
  var jetzt = 0;
  var timer = null;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fertig(b) { return b.complete && b.naturalWidth > 0 && !b.hasAttribute('data-src'); }

  function laden(b) {
    if (!b.hasAttribute('data-src')) return;
    if (b.getAttribute('data-srcset')) b.setAttribute('srcset', b.getAttribute('data-srcset'));
    b.setAttribute('src', b.getAttribute('data-src'));
    b.removeAttribute('data-src');
    b.removeAttribute('data-srcset');
  }
  function alleLaden() { Array.prototype.forEach.call(bilder, laden); }

  function setzen(i) {
    jetzt = i;
    Array.prototype.forEach.call(bilder, function (b, n) { b.classList.toggle('is-on', n === i); });
    Array.prototype.forEach.call(punkte, function (p, n) {
      p.classList.toggle('is-on', n === i);
      p.setAttribute('aria-selected', n === i ? 'true' : 'false');
    });
  }

  /* Wechselt erst, wenn das Ziel geladen ist. Beim Klick wartet es darauf,
     beim Automatikwechsel wird ein noch nicht fertiges Bild uebersprungen. */
  function zeige(i, warten) {
    i = (i + bilder.length) % bilder.length;
    var b = bilder[i];
    laden(b);
    if (fertig(b)) { setzen(i); return; }
    if (warten) {
      b.addEventListener('load', function () { setzen(i); }, { once: true });
    } else {
      for (var k = 1; k < bilder.length; k++) {
        var n = (i + k) % bilder.length;
        if (n !== jetzt && fertig(bilder[n])) { setzen(n); return; }
      }
    }
  }

  function start() {
    if (ruhig || timer) return;
    timer = setInterval(function () { zeige(jetzt + 1, false); }, takt);
  }
  function stopp() { clearInterval(timer); timer = null; }

  Array.prototype.forEach.call(punkte, function (p, n) {
    p.addEventListener('click', function () { stopp(); zeige(n, true); });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopp(); else start();
  });

  var startX = null;
  media.addEventListener('touchstart', function (e) {
    startX = e.changedTouches[0].clientX;
  }, { passive: true });
  media.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var weg = e.changedTouches[0].clientX - startX;
    startX = null;
    if (Math.abs(weg) < 40) return;
    stopp();
    zeige(weg < 0 ? jetzt + 1 : jetzt - 1, true);
  }, { passive: true });

  /* Die weiteren Bilder erst holen, wenn das erste steht, dann ist die
     Leitung fuer das sichtbare Bild frei. */
  var erstes = bilder[0];
  function weiter() { alleLaden(); start(); }
  if (erstes.complete && erstes.naturalWidth > 0) weiter();
  else {
    erstes.addEventListener('load', weiter, { once: true });
    erstes.addEventListener('error', weiter, { once: true });
  }
})();

/* Warenkorb: Mengen und Entfernen ohne Seitenwechsel.
   Die Antwort von /cart/change.js bringt den neu gerenderten Abschnitt mit
   (sections), damit Summen, Rabatte und Zeilen immer von Shopify kommen.
   Faellt etwas aus, laedt die Seite normal neu, es geht nichts verloren. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cartpage]');
  if (!root || !window.fetch) return;

  var sectionId = root.getAttribute('data-section-id');
  var busy = false;
  var timers = {};

  function zaehler(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function ersetzen(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.querySelector('[data-cartpage]');
    var alt = document.querySelector('[data-cartpage]');
    if (!neu || !alt) { window.location.reload(); return; }
    var fokus = document.activeElement && document.activeElement.id;
    alt.innerHTML = neu.innerHTML;
    if (fokus) { var f = document.getElementById(fokus); if (f) f.focus(); }
    if (window.KJ_refreshStars) window.KJ_refreshStars();
  }

  function aendern(line, menge, zeile) {
    if (busy) return;
    busy = true;
    if (zeile) zeile.classList.add(menge === 0 ? 'is-gone' : 'is-busy');

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: menge, sections: [sectionId], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        busy = false;
        if (!res.ok) {
          if (zeile) {
            zeile.classList.remove('is-busy', 'is-gone');
            var fehler = zeile.querySelector('[data-line-error]');
            if (fehler) { fehler.textContent = res.d.description || res.d.message || 'Das hat nicht geklappt.'; fehler.hidden = false; }
            var input = zeile.querySelector('[data-qty-input]');
            if (input) input.value = input.defaultValue;
          }
          return;
        }
        zaehler(res.d.item_count);
        if (res.d.sections && res.d.sections[sectionId]) ersetzen(res.d.sections[sectionId]);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  function zeileVon(el) { return el.closest('.cline'); }

  root.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var weg = e.target.closest('[data-remove]');
    if (!minus && !plus && !weg) return;

    var zeile = zeileVon(e.target);
    if (!zeile) return;
    var line = parseInt(zeile.getAttribute('data-line'), 10);

    if (weg) {
      e.preventDefault();
      aendern(line, 0, zeile);
      return;
    }

    var input = zeile.querySelector('[data-qty-input]');
    var wert = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
    input.value = wert;
    clearTimeout(timers[line]);
    /* Kurz warten, damit drei schnelle Klicks nur eine Anfrage werden. */
    timers[line] = setTimeout(function () { aendern(line, wert, zeile); }, 350);
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var zeile = zeileVon(input);
    var wert = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    aendern(parseInt(zeile.getAttribute('data-line'), 10), wert, zeile);
  });

  /* Enter im Mengenfeld soll nicht zur Kasse schicken, sondern die Menge
     uebernehmen. */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-qty-input]')) return;
    e.preventDefault();
    e.target.blur();
  });
})();

/* Fragen per Mail (snippets/ask-form.liquid). Beim Absenden merkt sich der
   Browser, welches Formular es war. Shopify laedt danach die Seite mit
   contact_posted=true neu, dann erscheint der Dank nur an diesem Formular und
   nicht zusaetzlich in anderen Kontaktformularen der Seite. */
(function () {
  'use strict';

  Array.prototype.forEach.call(document.querySelectorAll('form.askform'), function (f) {
    var seite = f.querySelector('[data-ask-page]');
    if (seite) seite.value = window.location.href.split('?')[0];
    f.addEventListener('submit', function () {
      var knopf = f.querySelector('[data-ask-key]');
      try { sessionStorage.setItem('kj-ask-sent', knopf ? knopf.getAttribute('data-ask-key') : ''); } catch (e) {}
      if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird gesendet …'; }
    });
  });

  var key = null;
  try { key = sessionStorage.getItem('kj-ask-sent'); } catch (e) {}
  if (!key || !/contact_posted=true/.test(window.location.search)) return;

  /* Andere Kontaktformulare der Seite zeigen sonst ebenfalls "Danke". */
  Array.prototype.forEach.call(document.querySelectorAll('form:not(.askform) .form-note--ok'), function (n) { n.hidden = true; });

  try { sessionStorage.removeItem('kj-ask-sent'); } catch (e) {}
  if (key === 'help') return; /* die Schnellhilfe zeigt ihren Dank selbst */
  var box = document.querySelector('[data-ask-box="' + key + '"]');
  if (!box) return;
  box.open = true;
  var ok = box.querySelector('.askform__ok');
  var felder = box.querySelector('.askform__fields');
  if (ok) ok.hidden = false;
  if (felder) felder.hidden = true;
  setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 200);
})();


/* Rabattcode kopieren (snippets/discount-code.liquid) und die
   Bestaetigungsseite nach dem Klick in der Newsletter-Mail. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-dcode-copy]');
    if (!knopf) return;
    var box = knopf.closest('[data-dcode]');
    var code = box ? box.querySelector('[data-dcode-value]').textContent.trim() : '';
    var label = knopf.querySelector('[data-dcode-copy-label]');
    function fertig() {
      box.classList.add('is-copied');
      if (label) label.textContent = 'Kopiert';
      setTimeout(function () { box.classList.remove('is-copied'); if (label) label.textContent = 'Kopieren'; }, 2200);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(fertig, fertig);
    } else {
      var t = document.createElement('textarea');
      t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); fertig();
    }
  });

  if (!/^\/account\/subscribe/.test(window.location.pathname)) return;
  var vorlage = document.querySelector('[data-subok-template]');
  var main = document.querySelector('main') || document.getElementById('main');
  if (!vorlage || !main || main.querySelector('[data-subok]')) return;
  main.classList.add('is-subok');
  main.insertBefore(vorlage.content.cloneNode(true), main.firstChild);
})();
